/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const MathUtils = require('../../geometry/MathUtils');

const DataType = {
	OBJECT: 0,
	ARRAY: 1,
	ARRAYITEM: 2,
	STRING: 3,
	NUMBER: 4,
	BOOLEAN: 5,
	CUSTOM: 6
};

module.exports = class TreeItem {
	constructor(id, key, value, depth, expanded, color, fontcolor, checked) {
		this.id = id;
		this.key = key;
		this.value = value;
		this.depth = depth;
		this.expanded = expanded;
		this.color = color;
		this.fontcolor = fontcolor;
		this.checked = checked;

		this.visible = true;
		this.editable = true;
	}

	copy() {
		const copy = new TreeItem(
			this.id,
			this.key,
			this.value,
			this.depth,
			this.expanded,
			this.color,
			this.fontcolor,
			this.checked
		);

		copy.visible = this.visible;
		copy.level = this.level;
		copy.drawlevel = this.drawlevel;
		copy.parent = this.parent;
		copy.type = this.type;
		copy.editable = this.editable;

		return copy;
	}

	static fromMessage(message, metadata, target) {
		let key;

		if (target === 'outboxcontainer') {
			key = metadata.id;
		} else if (metadata.label && metadata.label.length > 0) {
			key = metadata.label;
		} else if (metadata.consumer && metadata.consumer.length > 0) {
			key = metadata.consumer;
		} else if (metadata.source && metadata.source.length > 0) {
			key = metadata.source;
		} else {
			key = 'Message';
		}

		let value;
		if (metadata.arrivalTime) {
			const date = MathUtils.excelDateToJSDate(metadata.arrivalTime);
			value = `${date.toLocaleTimeString()}.${date.getMilliseconds().toString().padStart(3,'0')}`;
		} else {
			value = metadata.id;
		}

		const item = new TreeItem(
			(metadata.id && metadata.id.length > 0) ? metadata.id : message.id,
			key,
			value,
			0,
			null,
		);

		item.type = DataType.STRING;
		item.parent = -1;
		item._json = JSON.stringify(message);

		return item;
	}

	static get DataType() {
		return DataType;
	}

};
